import { isFilled } from '@prismicio/client';
import { asLink, asText } from '@prismicio/helpers';
import { PrismicRichText } from '@prismicio/react';
import React from 'react';
import styled from 'styled-components';

import { Button } from './ui';

const Section = styled.section`
  p a {
    text-decoration: underline;
  }
  .richtext--content {
    margin-top: 20px;
    li,
    p {
      margin-bottom: 20px;
      line-height: 1.5;
      &:last-child {
        margin-bottom: 0;
      }
    }
    li {
      list-style: disc;
      margin-inline-start: 20px;
    }
  }
`;

export default function BlockHeroTextAltSlice({ slice, sliceIndex }) {
  const sectionId = `block-hero-a-text-${sliceIndex}`;
  const { primary } = slice;
  const { button, button_link, description, eyebrow, heading } = primary;
  return (
    <>
      <Section id={sectionId}>
        <div className="container pb-20 pt-16 md:pb-20 md:pt-20">
          <div className="lg:grid lg:grid-cols-12">
            {asText(eyebrow.richText) ? (
              <div className="col-span-4 md:col-span-8 lg:grid-cols-12">
                <div className="eyebrow p5 line color--grey-4 fade-up mb-10">
                  {asText(eyebrow.richText)}
                </div>
              </div>
            ) : (
              <></>
            )}
            <div className="lg:col-span-5">
              <div className="h2 color--primary fade-up bg--blog">
                <PrismicRichText field={heading.richText} />
              </div>
            </div>
            <div className="lg:col-span-5 lg:col-start-7">
              <div className="richtext--content fade-up">
                <PrismicRichText field={description.richText} />
              </div>
              {isFilled.richText(button?.richText) && (
                <div className="fade-up mt-12 flex items-center">
                  {isFilled.link(button_link) ? (
                    <Button variant="primary" href={asLink(button_link)}>
                      {asText(button.richText)}
                    </Button>
                  ) : (
                    <Button globalTypeform>{asText(button.richText)}</Button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}
